import { Injectable } from '@angular/core';

/**
 * Generates unique Event_Deduplication_Id values (UUIDs) for verified submissions.
 *
 * One ID is generated per Verified_Submission before any conversion event fires,
 * then reused for:
 * - the Facebook Pixel event `eventID`
 * - the GA4 conversion event parameter
 * - the backend payload for server-side CAPI reporting
 *
 * Distinct submissions get distinct IDs (crypto.randomUUID guarantees uniqueness).
 *
 * Not providedIn root — provided per embed instance alongside ConsentService.
 *
 * Requirements: 10.1, 10.2, 10.3, 10.4
 */
@Injectable()
export class DedupIdService {
  /** The most recently generated ID, exposed for debugging/testing. */
  lastId: string | null = null;

  /**
   * Generate a new Event_Deduplication_Id (UUID v4).
   *
   * The caller (TrackingService) invokes this exactly once per Verified_Submission,
   * before any conversion event fires, and passes the result to GA4, Pixel, and
   * the backend payload.
   */
  generate(): string {
    const id = crypto.randomUUID();
    this.lastId = id;
    return id;
  }
}
